module.exports = __webpack_public_path__ + "img/guidebook2.3e7cc054.png";